/**
 * Maps a failed streamChat result to the widget's status + i18n error key.
 * Prefers the server-provided error `code` (from the {error:{code}} envelope),
 * falling back to the HTTP status when no code is present.
 *
 * @param {{ status: number, code: string|null }} result
 * @returns {{ status: string, errorKey: string }}
 */
export function mapResultToState({ status, code }) {
    if (code === 'cooldown') {
        return { status: 'blocked', errorKey: 'paused' };
    }
    if (code === 'rate_limited' || status === 429) {
        return { status: 'rate-limited', errorKey: 'rateLimited' };
    }
    if (code === 'input_rejected' || status === 422) {
        return { status: 'error', errorKey: 'inputRejected' };
    }
    if (code === 'token_cap' || status === 0 || status >= 500) {
        return { status: 'offline', errorKey: 'offline' };
    }
    return { status: 'error', errorKey: 'error' };
}
